import { ActivationBanner } from "../../components/ActivationBanner"
import { SettingsNavLinks } from "../../components/SettingsNavLinks"
import { Card, SwitchAppButton } from "../../components"
import { Select, TextInput } from "../../ui";



export const View = () =>{

    return(

        <>
            <SettingsNavLinks
      navtitle="Settings"
      navtitlelink="Account details"
      />
      <ActivationBanner 
            title="Please you need to activate your profile"
            subtitle="0ur guide will help you complete your Business profile and you’ll start receiving payments. Click this banner to complete your set-up."
            urlTarget="/onboarding"
      />
      <div className="card-container-account-details ">
      <Card>
          <div className="account-name">
            <strong>Account name</strong>
            <TextInput  />
          </div>
          <div className="account-name">
            <strong>Country</strong>
            <Select 
            />
          </div>
          <div className="account-name">
            <strong>Email verification</strong>
            <div>Click <span>here</span>  to verify now email now.</div>
          </div>
          <div className="account-details-button ">
                <SwitchAppButton
                className="account-details-success-primary "
                kind="success"  onClick={ (): void =>{("")} }            
                >Cancel</SwitchAppButton>
                <SwitchAppButton
                className="account-details-success-primary "
                kind="primary"  onClick={ (): void =>{("")} }            
                >Save </SwitchAppButton>
            </div>
      </Card>
      </div>
      <Card>
        <div className="deactivate-account">
        <div>
        <strong>Deactivate Account</strong>
            <p>Deactivating your SwitchApp account means you will be unable to receive or recover
               any of your payment history or account information.</p>
        </div>
        
        <div className="float-right mb-5">
                <SwitchAppButton
                className="switchapp-themed "
                kind="danger"  onClick={ (): void =>{("")} }            
                >Deactivate account</SwitchAppButton>
                
            </div>
        </div>
     
          </Card>
        </>
    )
}